'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _ThrowError = require('../utils/ThrowError');

var _Links = require('../utils/Links');

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _UIClickable = require('./UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIButton = _react2.default.createClass({
  displayName: 'UIButton',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    _useNativeButton: _react.PropTypes.bool,
    active: _react.PropTypes.bool.isRequired,
    'aria-pressed': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    external: _react.PropTypes.bool.isRequired,
    href: _validHref2.default,
    hovered: _react.PropTypes.bool,
    onClick: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    responsive: _react.PropTypes.bool.isRequired,
    size: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.SIZE_CLASSES)).isRequired,
    tabIndex: _react.PropTypes.number,
    type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _useNativeButton: true,
      active: false,
      disabled: false,
      external: false,
      responsive: true,
      size: 'default',
      tabIndex: 0,
      type: 'button',
      use: 'secondary'
    };
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;


    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;

    if (this.props.disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  getClassName: function getClassName(_ref, _ref2) {
    var active = _ref.active,
        block = _ref.block,
        className = _ref.className,
        disabled = _ref.disabled,
        hovered = _ref.hovered,
        responsive = _ref.responsive,
        size = _ref.size;
    var computedUse = _ref2.computedUse;

    var unstyled = computedUse === 'unstyled';
    return (0, _reactUtils.classNames)('btn', 'uiButton', 'private-button', _ButtonConstants.SIZE_CLASSES[size] || _ButtonConstants.SIZE_CLASSES.default, _ButtonConstants.USE_CLASSES[computedUse], className, {
      'active private-button--active': active && !unstyled,
      'btn-block private-button--block': block && !unstyled,
      'disabled private-button--disabled': disabled && !unstyled,
      'private-button--non-responsive': !responsive,
      'private-button--non-link': _ButtonConstants.LINK_USES.indexOf(computedUse) === -1,
      'private-button--hover': hovered
    });
  },
  getTabIndex: function getTabIndex(_ref3) {
    var disabled = _ref3.disabled,
        tabIndex = _ref3.tabIndex;

    return disabled ? -1 : tabIndex;
  },
  getUse: function getUse(_ref4) {
    var use = _ref4.use;

    return use && _ButtonConstants.USE_CLASSES[use] ? use : 'secondary';
  },
  getSecurityTaggedLink: function getSecurityTaggedLink(_ref5, _ref6) {
    var href = _ref5.href;
    var link = _ref6.link;

    if ((0, _UnsafeUrl.isUnsafeUrl)(href)) {
      (0, _ThrowError.throwErrorAsync)(new Error('UIButton: Detected XSS attempt! href="' + href + '"'));
      return _react2.default.createElement(
        _UnsafeUrl.XSSTooltip,
        null,
        link
      );
    }
    return link;
  },
  renderContents: function renderContents(_ref7) {
    var children = _ref7.children;

    return _react.Children.map(children, function (child) {
      if (child == null) {
        return null;
      }

      // in response to a breaking change in React 0.15
      // (https://facebook.github.io/react/blog/2016/04/07/react-v15.html#no-more-extra-ltspangts)
      // this wraps any bare strings within a <span> to provide a more
      // predictable DOM for applying automatic spacing rules.
      if (typeof child === 'string') {
        return _react2.default.createElement(
          'span',
          null,
          child
        );
      }

      return child;
    });
  },
  renderLink: function renderLink(_ref8, _ref9) {
    var disabled = _ref8.disabled,
        external = _ref8.external,
        href = _ref8.href,
        rel = _ref8.rel,
        target = _ref8.target,
        rest = _objectWithoutProperties(_ref8, ['disabled', 'external', 'href', 'rel', 'target']);

    var computedClassName = _ref9.computedClassName,
        computedTabIndex = _ref9.computedTabIndex,
        renderedContents = _ref9.renderedContents;

    var computedTarget = (0, _Links.getTarget)({ external: external, target: target });
    var computedRel = (0, _Links.getRel)({ rel: rel }, { computedTarget: computedTarget });
    var link = _react2.default.createElement(
      'a',
      _extends({}, rest, {
        'aria-disabled': disabled,
        className: computedClassName,
        href: (0, _UnsafeUrl.getSafeUrl)(href),
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        rel: computedRel,
        tabIndex: computedTabIndex,
        target: computedTarget
      }),
      renderedContents
    );
    return this.getSecurityTaggedLink({ href: href }, { link: link });
  },
  renderButton: function renderButton(_ref10, _ref11) {
    var _useNativeButton = _ref10._useNativeButton,
        disabled = _ref10.disabled,
        rest = _objectWithoutProperties(_ref10, ['_useNativeButton', 'disabled']);

    var computedClassName = _ref11.computedClassName,
        computedTabIndex = _ref11.computedTabIndex,
        renderedContents = _ref11.renderedContents;

    var ButtonComponent = _useNativeButton ? 'button' : _UIClickable2.default;
    return _react2.default.createElement(
      ButtonComponent,
      _extends({}, rest, {
        'aria-disabled': disabled,
        className: computedClassName,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        tabIndex: computedTabIndex
      }),
      renderedContents
    );
  },
  render: function render() {
    var propsNotUsedInRender = ['onClick', 'onMouseDown'];

    var _omit = (0, _underscore.omit)(this.props, propsNotUsedInRender),
        _useNativeButton = _omit._useNativeButton,
        active = _omit.active,
        block = _omit.block,
        children = _omit.children,
        className = _omit.className,
        disabled = _omit.disabled,
        external = _omit.external,
        hovered = _omit.hovered,
        href = _omit.href,
        rel = _omit.rel,
        responsive = _omit.responsive,
        size = _omit.size,
        tabIndex = _omit.tabIndex,
        target = _omit.target,
        use = _omit.use,
        rest = _objectWithoutProperties(_omit, ['_useNativeButton', 'active', 'block', 'children', 'className', 'disabled', 'external', 'hovered', 'href', 'rel', 'responsive', 'size', 'tabIndex', 'target', 'use']);

    var computedUse = this.getUse({ use: use });
    var computedClassName = this.getClassName({ active: active, block: block, className: className, disabled: disabled, hovered: hovered, responsive: responsive, size: size }, { computedUse: computedUse });
    var computedTabIndex = this.getTabIndex({ disabled: disabled, tabIndex: tabIndex });
    var renderedContents = this.renderContents({ children: children });

    return href ? this.renderLink(_extends({ disabled: disabled, external: external, href: href, rel: rel, target: target }, rest), { computedClassName: computedClassName, computedTabIndex: computedTabIndex, renderedContents: renderedContents }) : this.renderButton(_extends({ _useNativeButton: _useNativeButton, disabled: disabled }, rest), { computedClassName: computedClassName, computedTabIndex: computedTabIndex, renderedContents: renderedContents });
  }
});

exports.default = (0, _Hoverable2.default)(UIButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/button/UIButton.js
// module id = 46
// module chunks = 0 1